import { render, staticRenderFns } from "./PickupServer.vue?vue&type=template&id=5ceba6de&"
import script from "./PickupServer.vue?vue&type=script&lang=js&"
export * from "./PickupServer.vue?vue&type=script&lang=js&"
import style0 from "./PickupServer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports